import React, { Component } from 'react'; 
import _ from 'lodash';
import '../../Resources/css/Inventory.css';
import {Row, Col, Button}  from 'react-bootstrap';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; 


export default class InventoryFileMapping extends Component { 
  constructor(props){
    super(props)
    this.state = {
      selectedregionName:[],
      selectedclients:[],
      selectedProcess:[],
      selectedcenterName:[],      
    }
    this.json=[]
  }
  componentDidMount(){
		this.props.action.actioninventoryMaster()
  }
  UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEqual(nextProps.action.showModalLogin, this.props.action.showModalLogin) && nextProps.action.showModalLogin === false){     
      this.props.action.actioninventoryMaster()
    }
  } 	
  regionNames = () => {
    const{masterinventory} = this.props;
    if(!_.isEmpty(masterinventory)){
      let regionNames = _.filter(masterinventory.regions, {"status":"ACTIVE"});
      return regionNames;
    }
  }
  handleSelectRegion = (e) => {
    this.setState({selectedregionName: e})   
    this.json.push(this.state.selectedregionName);
  }
  centerNames = () => {
    const{masterinventory} = this.props;
    if(!_.isEmpty(masterinventory)){
    let centerNames = _.filter(masterinventory.centers, {"status":"ACTIVE"});  
    return centerNames;
    }
  }
  handleSelectRegionCenter = (e) => {
    this.setState({selectedcenterName: e})    
    this.json[0]={...this.json[0], 'centers':[...this.state.selectedcenterName]}
  }
  clientNames = () => {
    const{masterinventory} = this.props;
    if(!_.isEmpty(masterinventory)){
    let clientNames = _.filter(masterinventory.clients, {"status":"ACTIVE"});
    return clientNames;
    }
  }
  handleSelectRegionClients = (e) => {
    this.setState({selectedclients: e})    
  }
  processNames = () => {
    const{masterinventory} = this.props;
    if(!_.isEmpty(masterinventory)){
    let processNames = _.filter(masterinventory.processes, {"status":"ACTIVE"}); 
    return processNames;
    }
  }
  handleSelectRegionProcess = (e) => {
    this.setState({selectedProcess: e})    
  }
 
  validateForm = () =>{
    const {selectedclients,selectedregionName, selectedProcess,selectedcenterName} = this.state;
      if(selectedcenterName.length>0 && selectedclients.length >0 && selectedProcess.length > 0 && !_.isEmpty(selectedregionName)){
        return true }
  } 
  finalJSon = () => {
    const{selectedregionName,  selectedclients, selectedProcess, selectedcenterName} = this.state;
    let centers = _.map(selectedcenterName, (cx) => { return({'inventoryCenterId':cx.id, 'inventoryCenterName':cx.label})})
    let clients = _.map(selectedclients, (cx) => { return({'inventoryClientId':cx.id, 'inventoryClientName':cx.label})})
    let process = _.map(selectedProcess, (cx) => { return({'inventoryProcessId':cx.id, 'inventoryProcessName':cx.label})})
    let obj = {'inventoryRegionId': selectedregionName.id, 'inventoryRegionName':selectedregionName.label,
               "centers":centers,  "clients":clients,  "processes": process}    
    this.props.action.actioninventoryMapping(obj)
    this.setState({selectedregionName:[], selectedclients:[], selectedProcess:[], selectedcenterName:[],
     })
  }
  render(){
    return(
    <div>
      <Row>
        <Col>Region Name</Col>
        <Col>
          <Picky keepOpen={false}
            value={this.state.selectedregionName}
            options={this.regionNames()}
            onChange={this.handleSelectRegion}
            open={false}
            valueKey="label"
            labelKey="label"
            multiple={false}
            includeSelectAll={true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Region'
            dropdownHeight={600}
          /> 
        </Col>
      </Row>
      <Row>
        <Col>
          Center Name</Col>
          <Col>
          <Picky keepOpen={false}
            value={this.state.selectedcenterName}
            options={this.centerNames()}
            onChange={this.handleSelectRegionCenter}
            open={false}
            valueKey="label"
            labelKey="label"
            multiple={true}
            includeSelectAll={true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Center'
            dropdownHeight={600}
          />
        </Col>
      </Row>     
      <Row>       
        <Col>
        Client Name</Col>
        <Col>
          <Picky keepOpen={false}
            value={this.state.selectedclients}
            options={this.clientNames()}
            onChange={this.handleSelectRegionClients}
            open={false}
            valueKey="label"
            labelKey="label"
            multiple={true}
            includeSelectAll={true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Clients'
            dropdownHeight={600}
          /> 
        </Col>
      </Row>
      <Row>
        <Col>
          Process Name
        </Col><Col>
          <Picky keepOpen={false}
            value={this.state.selectedProcess}
            options={this.processNames()}
            onChange={this.handleSelectRegionProcess}
            open={false}
            valueKey="label"
            labelKey="label"
            multiple={true}
            includeSelectAll={true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Process'
            dropdownHeight={600}
          /> 
        </Col>
      </Row>
      <br/>
      <Row><Col className='centeredElement'><Button onClick={this.finalJSon}
      size='md' className='buttonwidth'
      disabled={!this.validateForm()}>MAP</Button></Col></Row>
    </div>)
   }
}